"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
exports.default = () => (React.createElement("section", null,
    React.createElement("div", { className: "container" },
        React.createElement("h1", null, "Legal Notice / Imprint"),
        React.createElement("h3", null, "Information provided according to sec. 5 German Telemedia Act (TMG):"),
        React.createElement("p", null,
            React.createElement("span", { className: "slogan" }, "smapiot GmbH"),
            React.createElement("br", null),
            "Weidenstrasse 14a",
            React.createElement("br", null),
            "85662 Hohenbrunn",
            React.createElement("br", null),
            "Germany"),
        React.createElement("h3", null, "Contact:"),
        React.createElement("p", null,
            "Telephone:+49 (0) 8102 9998476",
            React.createElement("br", null),
            "Fax: +49 (0) 8102 9984395",
            React.createElement("br", null),
            "E-Mail: info@smapiot.com"),
        React.createElement("h3", null, "Represented by:"),
        React.createElement("p", null, "Lothar Sch\u00F6ttner"),
        React.createElement("h3", null, "Register entry:"),
        React.createElement("p", null,
            "Registering court: District Court Munich",
            React.createElement("br", null),
            "Registration number: HRB 214798"),
        React.createElement("h3", null, "VAT number:"),
        React.createElement("p", null,
            "VAT ID number according to sec. 27a German Value Added Tax Act:",
            React.createElement("br", null),
            "DE297589818"),
        React.createElement("h3", null, "Information reg. Professional Indemnity Insurance:"),
        React.createElement("p", null,
            "Name and residence of insurer:",
            React.createElement("br", null),
            "Allianz Versicherungs-AG",
            React.createElement("br", null),
            "10900 Berlin",
            React.createElement("br", null),
            "Scope of insurance: Worldwide with exception of US and Canada"))));
